<script setup>
  import {inject, ref} from "vue";

  defineOptions({
    name: "PagesRecordResultPatientDataAdditionalInfo",
  });

  const props = defineProps({
    record: {
      type: Object,
      required: true,
    },
  });

  const privacy = inject("$privacy");

  const info = ref(null);

  privacy.decryptValue(props.record.info).then((plaintext) => {
    if (plaintext !== null) {
      info.value = plaintext.replaceAll(/\r\n|\r/g, "\n");
    }
  });
</script>

<template>
  <div v-if="info" class="py-2 sm:grid sm:grid-cols-4 sm:gap-4" :data-test="getTestId('result-additional-info')">
    <dt class="font-semibold text-gray-900">Weitere Angaben zum Patienten</dt>
    <dd class="mt-1 whitespace-pre-line text-gray-700 sm:col-span-3 sm:mt-0" v-text="info" />
  </div>
</template>
